function request(actionType) {
  return {
    type: actionType,
  };
}

function success(actionType, response) {
  return {
    type: actionType,
    payload: response,
  };
}

function failure(actionType, error) {
  return {
    type: actionType,
    payload: error,
  };
}

function setNullList(actionType) {
  return {
    type: actionType,
    payload: [],
  };
}

function setNull(actionType) {
  return {
    type: actionType,
    payload: null,
  };
}


//User Sign Up and Log In

const USER_LOGIN = {
  USER_LOGIN_REQUEST: "USER_LOGIN_REQUEST",
  USER_LOGIN_SUCCESS: "USER_LOGIN_SUCCESS",
  USER_LOGIN_FAILURE: "USER_LOGIN_FAILURE",
};

const ADD_MENU = {

  // Add MENU
  ADD_MENU_REQUEST: "ADD_MENU_REQUEST",
  ADD_MENU_SUCCESS: "ADD_MENU_SUCCESS",
  ADD_MENU_FAILURE: "ADD_MENU_FAILURE",

  // Get ALl MENU
  GET_ALL_MENU_REQUEST: "GET_ALL_MENU_REQUEST",
  GET_ALL_MENU_SUCCESS: "GET_ALL_MENU_SUCCESS",
  GET_ALL_MENU_FAILURE: "GET_ALL_MENU_FAILURE",

  // Get Single Menu
  GET_MENU_REQUEST: "GET_MENU_REQUEST",
  GET_MENU_SUCCESS: "GET_MENU_SUCCESS",
  GET_MENU_FAILURE: "GET_MENU_FAILURE",

  // Update Menu
  UPDATE_MENU_REQUEST: "UPDATE_MENU_REQUEST",
  UPDATE_MENU_SUCCESS: "UPDATE_MENU_SUCCESS",
  UPDATE_MENU_FAILURE: "UPDATE_MENU_FAILURE",

  // Delete Menu
  DELETE_MENU_REQUEST: "DELETE_MENU_REQUEST",
  DELETE_MENU_SUCCESS: "DELETE_MENU_SUCCESS",
  DELETE_MENU_FAILURE: "DELETE_MENU_FAILURE",
};

const MENU_ITEM = {

  // Add MENU Item
  ADD_MENU_ITEM_REQUEST: "ADD_MENU_ITEM_REQUEST",
  ADD_MENU_ITEM_SUCCESS: "ADD_MENU_ITEM_SUCCESS",
  ADD_MENU_ITEM_FAILURE: "ADD_MENU_ITEM_FAILURE",

  // Update MENU Item
  UPDATE_MENU_ITEM_REQUEST: "UPDATE_MENU_ITEM_REQUEST",
  UPDATE_MENU_ITEM_SUCCESS: "UPDATE_MENU_ITEM_SUCCESS",
  UPDATE_MENU_ITEM_FAILURE: "UPDATE_MENU_ITEM_FAILURE",

  // Update Single MENU Item
  GET_MENU_ITEM_REQUEST: "GET_MENU_ITEM_REQUEST",
  GET_MENU_ITEM_SUCCESS: "GET_MENU_ITEM_SUCCESS",
  GET_MENU_ITEM_FAILURE: "GET_MENU_ITEM_FAILURE",

  // Delete Menu Item
  DELETE_MENU_ITEM_REQUEST: "DELETE_MENU_REQUEST",
  DELETE_MENU_ITEM_SUCCESS: "DELETE_MENU_SUCCESS",
  DELETE_MENU_ITEM_FAILURE: "DELETE_MENU_FAILURE",

  // Clone Menu Item
  CLONE_MENU_ITEM_REQUEST: "CLONE_MENU_REQUEST",
  CLONE_MENU_ITEM_SUCCESS: "CLONE_MENU_SUCCESS",
  CLONE_MENU_ITEM_FAILURE: "CLONE_MENU_FAILURE",
}

const EXTRA_MENU_ITEM = {

  // Add Extra MENU Item
  ADD_EXTRA_MENU_ITEM_REQUEST: "ADD_EXTRA_MENU_ITEM_REQUEST",
  ADD_EXTRA_MENU_ITEM_SUCCESS: "ADD_EXTRA_MENU_ITEM_SUCCESS",
  ADD_EXTRA_MENU_ITEM_FAILURE: "ADD_EXTRA_MENU_ITEM_FAILURE",

  // Update Extra MENU Item
  UPDATE_EXTRA_MENU_ITEM_REQUEST: "UPDATE_EXTRA_MENU_ITEM_REQUEST",
  UPDATE_EXTRA_MENU_ITEM_SUCCESS: "UPDATE_EXTRA_MENU_ITEM_SUCCESS",
  UPDATE_EXTRA_MENU_ITEM_FAILURE: "UPDATE_EXTRA_MENU_ITEM_FAILURE",

  // Update Extra Single MENU Item
  GET_EXTRA_MENU_ITEM_REQUEST: "GET_EXTRA_MENU_ITEM_REQUEST",
  GET_EXTRA_MENU_ITEM_SUCCESS: "GET_EXTRA_MENU_ITEM_SUCCESS",
  GET_EXTRA_MENU_ITEM_FAILURE: "GET_EXTRA_MENU_ITEM_FAILURE",

  // Delete Extra Menu Item
  DELETE_EXTRA_MENU_ITEM_REQUEST: "DELETE_EXTRA_MENU_REQUEST",
  DELETE_EXTRA_MENU_ITEM_SUCCESS: "DELETE_EXTRA_MENU_SUCCESS",
  DELETE_EXTRA_MENU_ITEM_FAILURE: "DELETE_EXTRA_MENU_FAILURE",
}

const UPLOAD = {

  // Add MENU IMAGE
  ADD_MENU_IMAGE_REQUEST: "ADD_MENU_IMAGE_REQUEST",
  ADD_MENU_IMAGE_SUCCESS: "ADD_MENU_IMAGE_SUCCESS",
  ADD_MENU_IMAGE_FAILURE: "ADD_MENU_IMAGE_FAILURE",
}

const MENU_ITEM_OPTION = {

  // Add MENU ITEM OPTION
  ADD_MENU_ITEM_OPTION_REQUEST: "ADD_MENU_ITEM_OPTION_REQUEST",
  ADD_MENU_ITEM_OPTION_SUCCESS: "ADD_MENU_ITEM_OPTION_SUCCESS",
  ADD_MENU_ITEM_OPTION_FAILURE: "ADD_MENU_ITEM_OPTION_FAILURE",

  // Update MENU ITEM OPTION
  UPDATE_MENU_ITEM_OPTION_REQUEST: "UPDATE_MENU_ITEM_OPTION_REQUEST",
  UPDATE_MENU_ITEM_OPTION_SUCCESS: "UPDATE_MENU_ITEM_OPTION_SUCCESS",
  UPDATE_MENU_ITEM_OPTION_FAILURE: "UPDATE_MENU_ITEM_OPTION_FAILURE",

  // All Menu Item Option
  GET_All_MENU_ITEM_OPTION_REQUEST: "GET_All_MENU_ITEM_OPTION_REQUEST",
  GET_All_MENU_ITEM_OPTION_SUCCESS: "GET_All_MENU_ITEM_OPTION_SUCCESS",
  GET_All_MENU_ITEM_OPTION_FAILURE: "GET_All_MENU_ITEM_OPTION_FAILURE",

  // Single Menu Item Option for Update
  GET_MENU_ITEM_OPTION_REQUEST: "GET_MENU_ITEM_OPTION_REQUEST",
  GET_MENU_ITEM_OPTION_SUCCESS: "GET_MENU_ITEM_OPTION_SUCCESS",
  GET_MENU_ITEM_OPTION_FAILURE: "GET_MENU_ITEM_OPTION_FAILURE",

  // SET NULL
  SET_NULL_All_MENU_ITEM_OPTION_LIST: "SET_NULL_All_MENU_ITEM_OPTION_LIST",
  SET_NULL_MENU_ITEM_OPTION: "SET_NULL_MENU_ITEM_OPTION",

  // Delete Menu
  DELETE_MENU_ITEM_OPTION_REQUEST: "DELETE_MENU_ITEM_OPTION_REQUEST",
  DELETE_MENU_ITEM_OPTION_SUCCESS: "DELETE_MENU_ITEM_OPTION_SUCCESS",
  DELETE_MENU_ITEM_OPTION_FAILURE: "DELETE_MENU_ITEM_OPTION_FAILURE",

}

const MENU_ITEM_OPTION_ITEM = {
  // Delete Menu
  DELETE_MENU_ITEM_OPTION_ITEM_REQUEST: "DELETE_MENU_ITEM_OPTION_ITEM_REQUEST",
  DELETE_MENU_ITEM_OPTION_ITEM_SUCCESS: "DELETE_MENU_ITEM_OPTION_ITEM_SUCCESS",
  DELETE_MENU_ITEM_OPTION_ITEM_FAILURE: "DELETE_MENU_ITEM_OPTION_ITEM_FAILURE",
}


const ADD_ITEM_OPTION = {
  // Add MENU ITEM OPTION
  ADD_ITEM_OPTION_REQUEST: "ADD_ITEM_OPTION_REQUEST",
  ADD_ITEM_OPTION_SUCCESS: "ADD_ITEM_OPTION_SUCCESS",
  ADD_ITEM_OPTION_FAILURE: "ADD_ITEM_OPTION_FAILURE",

  // SET NULL
  SET_NULL_MENU_ITEM_OPTION_LIST: "SET_NULL_MENU_ITEM_OPTION_LIST",

  // Delete Menu
  DELETE_ITEM_OPTION_REQUEST: "DELETE_ITEM_OPTION_REQUEST",
  DELETE_ITEM_OPTION_SUCCESS: "DELETE_ITEM_OPTION_SUCCESS",
  DELETE_ITEM_OPTION_FAILURE: "DELETE_ITEM_OPTION_FAILURE",

}

const CUSTOMER = {
  // Get Single Customer
  GET_CUSTOMER_REQUEST: "GET_CUSTOMER_REQUEST",
  GET_CUSTOMER_SUCCESS: "GET_CUSTOMER_SUCCESS",
  GET_CUSTOMER_FAILURE: "GET_CUSTOMER_FAILURE",

  // Update Customer
  GET_ALL_CUSTOMER_REQUEST: "GET_ALL_CUSTOMER_REQUEST",
  GET_ALL_CUSTOMER_SUCCESS: "GET_ALL_CUSTOMER_SUCCESS",
  GET_ALL_CUSTOMER_FAILURE: "GET_ALL_CUSTOMER_FAILURE",
}

const LOCATION = {

  // Add LOCATION
  ADD_LOCATION_REQUEST: "ADD_LOCATION_REQUEST",
  ADD_LOCATION_SUCCESS: "ADD_LOCATION_SUCCESS",
  ADD_LOCATION_FAILURE: "ADD_LOCATION_FAILURE",

  // Get ALl LOCATION
  GET_ALL_LOCATION_REQUEST: "GET_ALL_LOCATION_REQUEST",
  GET_ALL_LOCATION_SUCCESS: "GET_ALL_LOCATION_SUCCESS",
  GET_ALL_LOCATION_FAILURE: "GET_ALL_LOCATION_FAILURE",

  // Get Single LOCATION
  GET_LOCATION_REQUEST: "GET_LOCATION_REQUEST",
  GET_LOCATION_SUCCESS: "GET_LOCATION_SUCCESS",
  GET_LOCATION_FAILURE: "GET_LOCATION_FAILURE",

  // Update LOCATION
  UPDATE_LOCATION_REQUEST: "UPDATE_LOCATION_REQUEST",
  UPDATE_LOCATION_SUCCESS: "UPDATE_LOCATION_SUCCESS",
  UPDATE_LOCATION_FAILURE: "UPDATE_LOCATION_FAILURE",

  // Delete LOCATION
  DELETE_LOCATION_REQUEST: "DELETE_LOCATION_REQUEST",
  DELETE_LOCATION_SUCCESS: "DELETE_LOCATION_SUCCESS",
  DELETE_LOCATION_FAILURE: "DELETE_LOCATION_FAILURE",
};


const ORDER = {

  // Get ALl ORDER
  GET_ALL_ORDER_REQUEST: "GET_ALL_ORDER_REQUEST",
  GET_ALL_ORDER_SUCCESS: "GET_ALL_ORDER_SUCCESS",
  GET_ALL_ORDER_FAILURE: "GET_ALL_ORDER_FAILURE",

  // Get Single ORDER
  GET_ORDER_REQUEST: "GET_ORDER_REQUEST",
  GET_ORDER_SUCCESS: "GET_ORDER_SUCCESS",
  GET_ORDER_FAILURE: "GET_ORDER_FAILURE",

  // Update ORDER
  UPDATE_ORDER_REQUEST: "UPDATE_ORDER_REQUEST",
  UPDATE_ORDER_SUCCESS: "UPDATE_ORDER_SUCCESS",
  UPDATE_ORDER_FAILURE: "UPDATE_ORDER_FAILURE",
}

const ROOM = {

  // Add ROOM
  ADD_ROOM_REQUEST: "ADD_ROOM_REQUEST",
  ADD_ROOM_SUCCESS: "ADD_ROOM_SUCCESS",
  ADD_ROOM_FAILURE: "ADD_ROOM_FAILURE",

  // Get ALl ROOM
  GET_ALL_ROOM_REQUEST: "GET_ALL_ROOM_REQUEST",
  GET_ALL_ROOM_SUCCESS: "GET_ALL_ROOM_SUCCESS",
  GET_ALL_ROOM_FAILURE: "GET_ALL_ROOM_FAILURE",

  // Get Single ROOM
  GET_ROOM_REQUEST: "GET_ROOM_REQUEST",
  GET_ROOM_SUCCESS: "GET_ROOM_SUCCESS",
  GET_ROOM_FAILURE: "GET_ROOM_FAILURE",

  // Update ROOM
  UPDATE_ROOM_REQUEST: "UPDATE_ROOM_REQUEST",
  UPDATE_ROOM_SUCCESS: "UPDATE_ROOM_SUCCESS",
  UPDATE_ROOM_FAILURE: "UPDATE_ROOM_FAILURE",

  // Delete ROOM
  DELETE_ROOM_REQUEST: "DELETE_ROOM_REQUEST",
  DELETE_ROOM_SUCCESS: "DELETE_ROOM_SUCCESS",
  DELETE_ROOM_FAILURE: "DELETE_ROOM_FAILURE",
};

const SERVING_PERIOD = {

  // Add ROOM
  ADD_SERVING_PERIOD_REQUEST: "ADD_SERVING_PERIOD_REQUEST",
  ADD_SERVING_PERIOD_SUCCESS: "ADD_SERVING_PERIOD_SUCCESS",
  ADD_SERVING_PERIOD_FAILURE: "ADD_SERVING_PERIOD_FAILURE",

  // Get ALl ROOM
  GET_ALL_SERVING_PERIOD_REQUEST: "GET_ALL_SERVING_PERIOD_REQUEST",
  GET_ALL_SERVING_PERIOD_SUCCESS: "GET_ALL_SERVING_PERIOD_SUCCESS",
  GET_ALL_SERVING_PERIOD_FAILURE: "GET_ALL_SERVING_PERIOD_FAILURE",

  // Get Single ROOM
  GET_SERVING_PERIOD_REQUEST: "GET_SERVING_PERIOD_REQUEST",
  GET_SERVING_PERIOD_SUCCESS: "GET_SERVING_PERIOD_SUCCESS",
  GET_SERVING_PERIOD_FAILURE: "GET_SERVING_PERIOD_FAILURE",

  // Update ROOM
  UPDATE_SERVING_PERIOD_REQUEST: "UPDATE_SERVING_PERIOD_REQUEST",
  UPDATE_SERVING_PERIOD_SUCCESS: "UPDATE_SERVING_PERIOD_SUCCESS",
  UPDATE_SERVING_PERIOD_FAILURE: "UPDATE_SERVING_PERIOD_FAILURE",

  // Delete ROOM
  DELETE_SERVING_PERIOD_REQUEST: "DELETE_SERVING_PERIOD_REQUEST",
  DELETE_SERVING_PERIOD_SUCCESS: "DELETE_SERVING_PERIOD_SUCCESS",
  DELETE_SERVING_PERIOD_FAILURE: "DELETE_SERVING_PERIOD_FAILURE",
};

const GENERAL_SETTING = {
  GET_GENERAL_SETTING_REQUEST: "GET_GENERAL_SETTING_REQUEST",
  GET_GENERAL_SETTING_SUCCESS: "GET_GENERAL_SETTING_SUCCESS",
  GET_GENERAL_SETTING_FAILURE: "GET_GENERAL_SETTING_FAILURE",
};

export {
  USER_LOGIN, ADD_MENU, MENU_ITEM, UPLOAD,
  EXTRA_MENU_ITEM, MENU_ITEM_OPTION, ADD_ITEM_OPTION,
  MENU_ITEM_OPTION_ITEM, LOCATION, CUSTOMER, ORDER, ROOM,
  SERVING_PERIOD, GENERAL_SETTING,
  request, success, failure, setNullList, setNull
};